export const linesData = [
  {
    id: "Fuel Exp",
    color: "hsl(99, 70%, 50%)",
    data: [
      {
        x: 0,
        y: 204,
      },
      {
        x: 1,
        y: 30,
      },
      {
        x: 2,
        y: 129,
      },
      {
        x: 3,
        y: 76,
      },
      {
        x: 4,
        y: 92,
      },
      {
        x: 5,
        y: 50,
      },
      {
        x: 6,
        y: 299,
      },
      {
        x: 7,
        y: 75,
      },
      {
        x: 8,
        y: 99,
      },
      {
        x: 9,
        y: 228,
      },
      {
        x: 10,
        y: 223,
      },
      {
        x: 11,
        y: 209,
      },
      {
        x: 12,
        y: 286,
      },
      {
        x: 13,
        y: 254,
      },
      {
        x: 14,
        y: 207,
      },
      {
        x: 15,
        y: 90,
      },
      {
        x: 16,
        y: 164,
      },
      {
        x: 17,
        y: 283,
      },
      {
        x: 18,
        y: 36,
      },
      {
        x: 19,
        y: 15,
      },
      {
        x: 20,
        y: 73,
      },
      {
        x: 21,
        y: 244,
      },
      {
        x: 22,
        y: 25,
      },
      {
        x: 23,
        y: 28,
      },
      {
        x: 24,
        y: 36,
      },
      {
        x: 25,
        y: 204,
      },
      {
        x: 26,
        y: 115,
      },
      {
        x: 27,
        y: 220,
      },
      {
        x: 28,
        y: 34,
      },
      {
        x: 29,
        y: 260,
      },
      {
        x: 30,
        y: 60,
      },
      {
        x: 31,
        y: 116,
      },
      {
        x: 32,
        y: 284,
      },
      {
        x: 33,
        y: 266,
      },
      {
        x: 34,
        y: 11,
      },
      {
        x: 35,
        y: 10,
      },
      {
        x: 36,
        y: 27,
      },
      {
        x: 37,
        y: 143,
      },
      {
        x: 38,
        y: 248,
      },
      {
        x: 39,
        y: 224,
      },
      {
        x: 40,
        y: 208,
      },
      {
        x: 41,
        y: 273,
      },
      {
        x: 42,
        y: 135,
      },
      {
        x: 43,
        y: 55,
      },
      {
        x: 44,
        y: 3,
      },
      {
        x: 45,
        y: 14,
      },
      {
        x: 46,
        y: 236,
      },
      {
        x: 47,
        y: 184,
      },
      {
        x: 48,
        y: 285,
      },
      {
        x: 49,
        y: 49,
      },
      {
        x: 50,
        y: 89,
      },
      {
        x: 51,
        y: 186,
      },
      {
        x: 52,
        y: 112,
      },
      {
        x: 53,
        y: 218,
      },
      {
        x: 54,
        y: 77,
      },
      {
        x: 55,
        y: 33,
      },
      {
        x: 56,
        y: 226,
      },
      {
        x: 57,
        y: 63,
      },
      {
        x: 58,
        y: 67,
      },
      {
        x: 59,
        y: 170,
      },
      {
        x: 60,
        y: 144,
      },
      {
        x: 61,
        y: 218,
      },
      {
        x: 62,
        y: 119,
      },
      {
        x: 63,
        y: 76,
      },
      {
        x: 64,
        y: 190,
      },
      {
        x: 65,
        y: 66,
      },
      {
        x: 66,
        y: 241,
      },
      {
        x: 67,
        y: 183,
      },
      {
        x: 68,
        y: 275,
      },
      {
        x: 69,
        y: 177,
      },
      {
        x: 70,
        y: 23,
      },
      {
        x: 71,
        y: 100,
      },
      {
        x: 72,
        y: 85,
      },
      {
        x: 73,
        y: 221,
      },
      {
        x: 74,
        y: 140,
      },
      {
        x: 75,
        y: 261,
      },
      {
        x: 76,
        y: 174,
      },
      {
        x: 77,
        y: 240,
      },
      {
        x: 78,
        y: 0,
      },
      {
        x: 79,
        y: 222,
      },
      {
        x: 80,
        y: 30,
      },
      {
        x: 81,
        y: 55,
      },
      {
        x: 82,
        y: 217,
      },
      {
        x: 83,
        y: 61,
      },
      {
        x: 84,
        y: 295,
      },
      {
        x: 85,
        y: 22,
      },
      {
        x: 86,
        y: 218,
      },
      {
        x: 87,
        y: 137,
      },
      {
        x: 88,
        y: 179,
      },
      {
        x: 89,
        y: 222,
      },
      {
        x: 90,
        y: 140,
      },
      {
        x: 91,
        y: 28,
      },
      {
        x: 92,
        y: 179,
      },
      {
        x: 93,
        y: 153,
      },
      {
        x: 94,
        y: 168,
      },
      {
        x: 95,
        y: 250,
      },
      {
        x: 96,
        y: 180,
      },
      {
        x: 97,
        y: 255,
      },
      {
        x: 98,
        y: 92,
      },
      {
        x: 99,
        y: 23,
      },
      {
        x: 100,
        y: 53,
      },
      {
        x: 101,
        y: 214,
      },
      {
        x: 102,
        y: 8,
      },
      {
        x: 103,
        y: 9,
      },
      {
        x: 104,
        y: 156,
      },
      {
        x: 105,
        y: 55,
      },
      {
        x: 106,
        y: 10,
      },
      {
        x: 107,
        y: 164,
      },
      {
        x: 108,
        y: 144,
      },
      {
        x: 109,
        y: 76,
      },
      {
        x: 110,
        y: 253,
      },
      {
        x: 111,
        y: 127,
      },
      {
        x: 112,
        y: 120,
      },
      {
        x: 113,
        y: 283,
      },
      {
        x: 114,
        y: 27,
      },
      {
        x: 115,
        y: 185,
      },
      {
        x: 116,
        y: 64,
      },
      {
        x: 117,
        y: 280,
      },
      {
        x: 118,
        y: 172,
      },
      {
        x: 119,
        y: 169,
      },
      {
        x: 120,
        y: 276,
      },
    ],
  },
  {
    id: "Fleet Utilization",
    color: "hsl(291, 70%, 50%)",
    data: [
      {
        x: 0,
        y: 14,
      },
      {
        x: 1,
        y: 114,
      },
      {
        x: 2,
        y: 280,
      },
      {
        x: 3,
        y: 226,
      },
      {
        x: 4,
        y: 44,
      },
      {
        x: 5,
        y: 32,
      },
      {
        x: 6,
        y: 207,
      },
      {
        x: 7,
        y: 281,
      },
      {
        x: 8,
        y: 155,
      },
      {
        x: 9,
        y: 65,
      },
      {
        x: 10,
        y: 203,
      },
      {
        x: 11,
        y: 188,
      },
      {
        x: 12,
        y: 117,
      },
      {
        x: 13,
        y: 87,
      },
      {
        x: 14,
        y: 137,
      },
      {
        x: 15,
        y: 6,
      },
      {
        x: 16,
        y: 76,
      },
      {
        x: 17,
        y: 124,
      },
      {
        x: 18,
        y: 243,
      },
      {
        x: 19,
        y: 278,
      },
      {
        x: 20,
        y: 86,
      },
      {
        x: 21,
        y: 208,
      },
      {
        x: 22,
        y: 137,
      },
      {
        x: 23,
        y: 194,
      },
      {
        x: 24,
        y: 121,
      },
      {
        x: 25,
        y: 225,
      },
      {
        x: 26,
        y: 10,
      },
      {
        x: 27,
        y: 296,
      },
      {
        x: 28,
        y: 261,
      },
      {
        x: 29,
        y: 292,
      },
      {
        x: 30,
        y: 63,
      },
      {
        x: 31,
        y: 42,
      },
      {
        x: 32,
        y: 100,
      },
      {
        x: 33,
        y: 262,
      },
      {
        x: 34,
        y: 244,
      },
      {
        x: 35,
        y: 236,
      },
      {
        x: 36,
        y: 228,
      },
      {
        x: 37,
        y: 270,
      },
      {
        x: 38,
        y: 16,
      },
      {
        x: 39,
        y: 69,
      },
      {
        x: 40,
        y: 73,
      },
      {
        x: 41,
        y: 73,
      },
      {
        x: 42,
        y: 161,
      },
      {
        x: 43,
        y: 0,
      },
      {
        x: 44,
        y: 46,
      },
      {
        x: 45,
        y: 149,
      },
      {
        x: 46,
        y: 292,
      },
      {
        x: 47,
        y: 138,
      },
      {
        x: 48,
        y: 191,
      },
      {
        x: 49,
        y: 262,
      },
      {
        x: 50,
        y: 155,
      },
      {
        x: 51,
        y: 170,
      },
      {
        x: 52,
        y: 169,
      },
      {
        x: 53,
        y: 249,
      },
      {
        x: 54,
        y: 80,
      },
      {
        x: 55,
        y: 176,
      },
      {
        x: 56,
        y: 91,
      },
      {
        x: 57,
        y: 138,
      },
      {
        x: 58,
        y: 103,
      },
      {
        x: 59,
        y: 222,
      },
      {
        x: 60,
        y: 114,
      },
      {
        x: 61,
        y: 277,
      },
      {
        x: 62,
        y: 43,
      },
      {
        x: 63,
        y: 239,
      },
      {
        x: 64,
        y: 189,
      },
      {
        x: 65,
        y: 181,
      },
      {
        x: 66,
        y: 123,
      },
      {
        x: 67,
        y: 120,
      },
      {
        x: 68,
        y: 5,
      },
      {
        x: 69,
        y: 128,
      },
      {
        x: 70,
        y: 288,
      },
      {
        x: 71,
        y: 149,
      },
      {
        x: 72,
        y: 71,
      },
      {
        x: 73,
        y: 153,
      },
      {
        x: 74,
        y: 227,
      },
      {
        x: 75,
        y: 281,
      },
      {
        x: 76,
        y: 84,
      },
      {
        x: 77,
        y: 254,
      },
      {
        x: 78,
        y: 279,
      },
      {
        x: 79,
        y: 172,
      },
      {
        x: 80,
        y: 27,
      },
      {
        x: 81,
        y: 81,
      },
      {
        x: 82,
        y: 198,
      },
      {
        x: 83,
        y: 81,
      },
      {
        x: 84,
        y: 281,
      },
      {
        x: 85,
        y: 96,
      },
      {
        x: 86,
        y: 130,
      },
      {
        x: 87,
        y: 131,
      },
      {
        x: 88,
        y: 278,
      },
      {
        x: 89,
        y: 119,
      },
      {
        x: 90,
        y: 155,
      },
      {
        x: 91,
        y: 184,
      },
      {
        x: 92,
        y: 73,
      },
      {
        x: 93,
        y: 32,
      },
      {
        x: 94,
        y: 114,
      },
      {
        x: 95,
        y: 13,
      },
      {
        x: 96,
        y: 299,
      },
      {
        x: 97,
        y: 274,
      },
      {
        x: 98,
        y: 49,
      },
      {
        x: 99,
        y: 96,
      },
      {
        x: 100,
        y: 208,
      },
      {
        x: 101,
        y: 226,
      },
      {
        x: 102,
        y: 80,
      },
      {
        x: 103,
        y: 111,
      },
      {
        x: 104,
        y: 149,
      },
      {
        x: 105,
        y: 282,
      },
      {
        x: 106,
        y: 219,
      },
      {
        x: 107,
        y: 119,
      },
      {
        x: 108,
        y: 211,
      },
      {
        x: 109,
        y: 291,
      },
      {
        x: 110,
        y: 245,
      },
      {
        x: 111,
        y: 112,
      },
      {
        x: 112,
        y: 75,
      },
      {
        x: 113,
        y: 139,
      },
      {
        x: 114,
        y: 14,
      },
      {
        x: 115,
        y: 37,
      },
      {
        x: 116,
        y: 57,
      },
      {
        x: 117,
        y: 67,
      },
      {
        x: 118,
        y: 291,
      },
      {
        x: 119,
        y: 30,
      },
      {
        x: 120,
        y: 85,
      },
    ],
  },
];

export const pieData = [
  {
    id: "fuel-cost",
    label: "Fuel Cost",
    value: 5000,
    color: "hsl(121, 70%, 50%)",
  },
  {
    id: "maintainance-cost",
    label: "Maintainance Cost",
    value: 50000,
    color: "hsl(169, 70%, 50%)",
  },
];
